import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ChangeCostsController', ChangeCostsController);

    /** @ngInject */
    function ChangeCostsController(
        $scope,
        $state,
        IssueCostsFactory,
        CostsService,
        LabourCostsFactory,
        LocalStorageService,
        MaterialCostsFactory
    ) {
        var vm = this;
        var companyEmployee;

        init();

        function init() {
            companyEmployee = LocalStorageService.getCompanyEmployee();

            vm.issue = $scope.ngDialogData.issue;
            vm.addCost = addCost;
            vm.editCost = editCost;
            vm.removeCost = removeCost;
            vm.canUserEditCosts = canUserEditCosts;
            vm.canUserAddCosts = canUserAddCosts;

            $scope.$on('cost-added', function (event, args) {
                vm.isUserAddingCost = false;
                vm.costs.results.push(args);
            });

            $scope.$on('cost-changed', function (event, args) {
                vm.isUserAddingCost = false;
                vm.costs.results[vm.cost.index] = args;
            });

            getCosts();
        }

        function getCosts() {
            IssueCostsFactory.get(
                companyEmployee.organization.party_uuid,
                vm.issue.id,
                {
                    page_size: 50,
                }
            ).then(function (response) {
                vm.costs = response.data;
                if (vm.cost && vm.cost.material) {
                    vm.material = vm.cost.material;
                } else {
                    vm.material = {};
                }
            });
        }

        function canUserEditCosts(): boolean {
            return companyEmployee.manager;
        }

        function canUserAddCosts(): boolean {
            return CostsService.canUserManageCosts(vm.issue, companyEmployee);
        }

        function addCost(costType) {
            vm.isUserAddingCost = true;
            vm.cost = { cost_type: costType };
        }

        function editCost(cost, index) {
            cost.index = index;
            vm.isUserAddingCost = true;
            vm.cost = cost;
        }

        function removeCost(costType, costId, index) {
            if (costType === 1) {
                MaterialCostsFactory.remove(
                    companyEmployee.organization.party_uuid,
                    vm.issue.id,
                    costId
                ).then(function () {
                    vm.costs.results.splice(index, 1);
                    refreshIssue();
                });
            } else if (costType === 2) {
                LabourCostsFactory.remove(
                    companyEmployee.organization.party_uuid,
                    vm.issue.id,
                    costId
                ).then(function () {
                    vm.costs.results.splice(index, 1);
                    refreshIssue();
                });
            }
        }

        function refreshIssue() {
            $state.reload('company_employee.issue_list.details');
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/change-costs/change-costs.controller.ts